import { render, staticRenderFns } from "./internationalPay.vue?vue&type=template&id=d2146632&scoped=true"
import script from "./internationalPay.vue?vue&type=script&lang=js"
export * from "./internationalPay.vue?vue&type=script&lang=js"
import style0 from "./internationalPay.vue?vue&type=style&index=0&id=d2146632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2146632",
  null
  
)

export default component.exports